import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Close, Menu } from "@mui/icons-material";
import KrishnaLogo from "../Assets/KPS_Logo.png";

export default function Navbar() {
  const location = useLocation();

  const menus = [
    { label: "Home", path: "/?Type=Home", type: "Home" },
    { label: "About Us", path: "/AboutUs?Type=AboutUs", type: "AboutUs" },

    {
      label: "Academics",
      children: [
        { label: "Fee Structure", path: "/FeeStructure?Type=FeeStructure", type: "FeeStructure" },
        { label: "School Timing", path: "/SchoolTiming?Type=SchoolTiming", type: "SchoolTiming" },
        { label: "Downloads", path: "/Documents?Type=Documents", type: "Documents" },
      ],
    },

    {
      label: "Gallery",
      children: [
        { label: "Image Gallery", path: "/ImageGallery?Type=ImageGallery", type: "ImageGallery" },
        { label: "Video Gallery", path: "/VideoGallery?Type=VideoGallery", type: "VideoGallery" },
      ],
    },

    {
      label: "Admission",
      children: [
        { label: "New Admission", path: "/AdmissionForm?Type=AdmissionForm", type: "AdmissionForm" },
      ],
    },

    { label: "Mandatory Disclosure", path: "/Disclosure?Type=Disclosure", type: "Mandatory Disclosure" },
    { label: "Verify TC", path: "/TcForm?Type=TcForm", type: "TcForm" },
    { label: "Contact Us", path: "/ContactUs?Type=ContactUs", type: "ContactUs" },
  ];

  const [active, setActive] = useState("Home");
  const [open, setOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setActive(params.get("Type") || "Home");
  }, [location.search]);

  return (
    <>
      <nav className="bg-white shadow-md sticky top-0 z-50 border-b border-[#ff4e1c]/10">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between h-20 lg:h-24">

            <div className="flex items-center gap-3">
              <img src={KrishnaLogo} alt="logo" className="h-10 sm:h-12 lg:h-16 w-auto" />
              <div>
                <h1 className="text-2xl font-medium text-[#ff4e1c] leading-tight">
                  KRISHNA PUBLIC SCHOOL
                </h1>
              </div>
            </div>

            <button className="text-2xl text-[#0A1F44] hover:text-[#ff4e1c] transition" onClick={() => setOpen(true)}>
              <Menu />
            </button>
          </div>
        </div>
      </nav>

      <div className={`fixed inset-0 bg-black/40 z-40 transition-opacity ${open ? "opacity-100 visible" : "opacity-0 invisible"}`} onClick={() => setOpen(false)} />

      <div className={`fixed top-0 right-0 h-full w-72 bg-white z-50 transform transition-transform duration-300 overflow-y-auto ${open ? "translate-x-0" : "translate-x-full"} z-[9999]`}>
        <div className="flex items-center justify-between px-4 py-4 border-b">
          <div className="flex items-center gap-2">
            <img src={KrishnaLogo} alt="logo" className="h-10 w-auto" />
            <div>
              <h2 className="text-sm font-bold text-gray-900">
                Krishna
              </h2>
              <p className="text-xs text-gray-600">Public School</p>
            </div>
          </div>

          <button className="text-2xl text-[#0A1F44] hover:text-[#ff4e1c]" onClick={() => setOpen(false)}>
            <Close />
          </button>
        </div>

        <div className="p-3 space-y-1">
          {menus.map((menu) => {
            if (!menu.children) {
              return (
                <Link key={menu.label} to={menu.path} onClick={() => setOpen(false)} className={`block px-4 py-3 text-sm font-medium rounded-lg transition ${active === menu.type ? "text-red-600 bg-red-100" : "text-gray-800 hover:text-red-600 hover:bg-red-100"}`}>
                  {menu.label}
                </Link>
              );
            }

            return (
              <div key={menu.label}>
                <button onClick={() => setOpenMenu(openMenu === menu.label ? null : menu.label)} className={`w-full text-left px-4 py-3 text-sm font-semibold text-gray-950 hover:bg-red-100 rounded-lg ${active === menu.type ? "text-red-600 bg-red-100" : "text-red-6000 hover:text-red-600 hover:bg-red-100"}`} >
                  {menu.label}
                </button>

                {openMenu === menu.label && (
                  <div className="ml-4 mt-1 space-y-1">
                    {menu.children.map((child) =>
                      child.type === "Disclosure" ? (
                        <a key={child.label} href={child.path} target="_blank" rel="noopener noreferrer"
                          onClick={() => { setOpen(false); setOpenMenu(null) }}
                          className="block px-4 py-2 text-sm rounded-lg text-gray-700 hover:text-red-600 hover:bg-red-100" >
                          {child.label}
                        </a>
                      ) : (
                        <Link key={child.label} to={child.path}
                          onClick={() => { setOpen(false); setOpenMenu(null) }}
                          className={`block px-4 py-2 text-sm rounded-lg transition ${active === child.type
                              ? "text-blue-950 bg-blue-100"
                              : "text-gray-700 hover:text-red-600 hover:bg-red-100"
                            }`}
                        >
                          {child.label}
                        </Link>
                      )
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>

      </div>
    </>
  );
}
